import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="bg-[#FFF8EC] min-h-screen xl:pt-32 pt-24 px-6">
     <div className=" mx-auto  p-8  rounded-lg">
      <section className="mb-6 ">
        <h1 className="text-4xl font-bold mb-6 text-center">Welcome to Net4Surge!</h1>
        <p className="mb-4 text-base">
          These Terms & Conditions ("Terms") govern your use of our website, <a href="https://www.Net4Surge.com" className="text-blue-600">www.Net4Surge.com</a>, and related services. By accessing or using our platform, you agree to comply with these Terms. If you do not agree, please refrain from using our services.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">1. Definitions</h2>
        <ul className="list-disc ml-6">
          <li><strong>"Net4Surge"</strong> refers to our business listing platform and associated services.</li>
          <li><strong>"User"</strong> refers to any individual, business, or entity accessing or using our services.</li>
          <li><strong>"Business Listing"</strong> refers to any company or entity listed on Net4Surge.</li>
          <li><strong>"Content"</strong> includes business information, reviews, images, text, and other materials shared on our platform.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">2. Eligibility</h2>
        <ul className="list-disc ml-6">
          <li>Provide accurate and truthful business and personal information.</li>
          <li>Use the platform legally and ethically.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">3. Business Listings & User Responsibilities</h2>
        <ul className="list-disc ml-6">
          <li>Businesses can create, edit, and manage their listings on Net4Surge.</li>
          <li>Users must provide accurate and updated business details.</li>
          <li>Any misleading, false, or inappropriate content is strictly prohibited.</li>
          <li>Listings must comply with local laws and regulations.</li>
          <li>Net4Surge reserves the right to verify, modify, or remove listings at its discretion.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">4. Content & Intellectual Property</h2>
        <ul className="list-disc ml-6">
          <li>Users are responsible for the content they upload.</li>
          <li>By submitting content, you grant Net4Surge a non-exclusive, royalty-free, worldwide license to use, modify, and display your content for business promotion.</li>
          <li>Do not upload copyrighted, offensive, or illegal content.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">5. Prohibited Activities</h2>
        <ul className="list-disc ml-6">
          <li>Users agree NOT to:</li>
          <li>Use Net4Surge for fraudulent, misleading, or illegal activities.</li>
          <li>Upload harmful software (viruses, malware, etc.).</li>
          <li>Post defamatory, abusive, or hateful content.</li>
          <li>Use bots, scrapers, or automated systems to collect data.</li>
          <li>Engage in unauthorized advertising or spam.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">6. Reviews & Ratings</h2>
        <ul className="list-disc ml-6">
          <li>Users may leave genuine and honest reviews for businesses.</li>
          <li>False, misleading, or malicious reviews are not allowed.</li>
          <li>Net4Surge reserves the right to remove inappropriate reviews.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">7. Account Suspension & Termination</h2>
        <ul className="list-disc ml-6">
          <li>Net4Surge reserves the right to suspend or terminate accounts without notice if:</li>
          <li>The user violates these Terms.</li>
          <li>Fraudulent or unlawful activities are detected.</li>
          <li>The account remains inactive for an extended period.</li>
          <li>Users may delete their accounts by contacting <a href="mailto:support@net4surge.com" className="text-blue-600">support@net4surge.com</a>.</li>
        </ul>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">8. Limitation of Liability</h2>
        <p className="text-base">Net4Surge provides a business listing platform and does not endorse or guarantee any business listed. We are not responsible for any losses, damages, or disputes arising from business transactions. Users interact with businesses at their own risk.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">9. Disclaimer</h2>
        <p className="text-base">Our platform operates “as is”, without warranties or guarantees. We do not guarantee continuous, error-free access to our website. Net4Surge is not liable for third-party content or actions.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">10. Privacy & Data Protection</h2>
        <p className="text-base">Our Privacy Policy governs the collection and use of your data. By using Net4Surge, you agree to our data practices. <a href="#" className="text-blue-600">Read Our Privacy Policy Here</a></p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">11. Third-Party Links</h2>
        <p className="text-base">Net4Surge may contain links to third-party websites. We are not responsible for their content, privacy policies, or business practices.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">12. Changes to These Terms</h2>
        <p className="text-base">Net4Surge may update these Terms at any time. Users will be notified of significant changes via email or website updates. Continued use of the platform implies acceptance of updated Terms.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">13. Governing Law & Dispute Resolution</h2>
        <p className="text-base">These Terms are governed by the laws. Any disputes shall be resolved through mediation, arbitration, or legal proceedings in Noida.</p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-bold text-left pb-2 mb-2">14. Contact Us</h2>
        <p className="text-base">For any questions regarding these Terms, please contact:</p>
        <address className="not-italic text-base">
          <strong>Email:</strong> <a href="mailto:support@net4surge.com" className="text-blue-600">support@net4surge.com</a><br />
          <strong>Address:</strong> A67, Sector 2, Noida, UP-201301
        </address>
      </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;

